import React from 'react'
import { ListGroup, Col, UncontrolledAlert} from 'reactstrap'
import Loader from 'react-loader-spinner'
import { ProvisionControllerForm, ControllerRegistrationListItem, InfoAlert } from '../../ui'
import {Controller, AppError} from "../../../models"
import {registerControllers, getTeam} from "../../../api"
import {pageHelpers} from "../"

import RegisterControllerIcon from 'react-icons/lib/fa/asterisk'

import '../../../stylesheets/Provision.css'

const REGISTRATION_STATE_STORAGE_KEY = "marksman_controller_registration_state"
const REGISTRATION_INFO_ALERT_KEY = "register_controller_1"

class RegisterPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token, user} = props

        let teamID = (user && user.activeTeam ? user.activeTeam : undefined)

        let oldStateFromStorage = sessionStorage.getItem(REGISTRATION_STATE_STORAGE_KEY)
        if (oldStateFromStorage) {
            this.state = JSON.parse(oldStateFromStorage)
            this.state.token = token
            this.state.teamID = teamID
        } else {
            this.state = {
                token,
                teamID,
                errors: [],
                loading: false,
                registeredControllers: [],
                teamName: null,
            }
        }

        this.submitForm = this.submitForm.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchTeam = this.fetchTeam.bind(this)
    }

    async componentDidMount() {
        let {token, teamID} = this.state
        if (token && teamID) {
            this.fetchTeam()
        }
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)
        const {token, user} = nextProps

        if (user && user.activeTeam) {
            let teamID = user.activeTeam
            await this.setState({teamID, token})
            if (token) {
                await this.fetchTeam()
            }
        } else {
            this.setState({token})
        }
    }

    async fetchTeam() {
        this.setState({loading: true})

        let {token, teamID} = this.state

        let teamName = ''
        if (teamID) {
            let team = await getTeam(token, teamID)
            teamName = team.name
        }

        this.setState({teamName, loading: false})
    }

    async submitForm(serialNumbers) {
        if (!serialNumbers || serialNumbers.length < 1 || serialNumbers.join('').length < 1) {
            let appError = new AppError("No Controller Specified", "Please enter a controller serial number to register.")
            this.setState({loading: false, errors: [appError]})
            return
        }

        this.setState({loading: true})
        let {registeredControllers, teamName, teamID} = this.state
        let controllers = []

        try {
            controllers = await registerControllers(this.token, serialNumbers, teamID, true)
        } catch (registrationErr) {
            console.log(registrationErr)

            let errTitle = "Failed to register controller"
            let errMsg

            try {
                let parsedMsg = JSON.parse(registrationErr.message)
                errMsg = parsedMsg.detail
            } catch (parsingErr) {}

            if (registrationErr.message && registrationErr.message.includes('valid dealer team id')) {
                errMsg = errMsg || `Only dealerships can register new Marksman controllers. ${teamName || "Your current team"} is not a dealership. If you're a member of multiple teams, please switch to a dealership team.`
            } else if (serialNumbers && serialNumbers.length > 1) {
                errMsg = errMsg || `There was an issue registering these ${serialNumbers.length} controllers. Please check the serial numbers and try again`
            } else if (serialNumbers && serialNumbers.length === 1) {
                errMsg = errMsg || `There was an issue registering ${serialNumbers[0]}. Please check the serial number and try again`
            } else {
                errMsg = errMsg || "There was an issue registering this controller. Please check the serial number and try again."
            }

            let appError = new AppError(errTitle, errMsg)
            this.setState({loading:false, errors:[appError]})
        }

        let newControllers = controllers.filter(c => !registeredControllers.includes(c))
        registeredControllers = registeredControllers.concat(newControllers)

        this.setState({loading:false, registeredControllers})
        sessionStorage.setItem(REGISTRATION_STATE_STORAGE_KEY, JSON.stringify(this.state))
    }

    handleWebSocketResponse(data) {
        let result = JSON.parse(data)
        let updatedController = Controller.fromAPIObject(result)
        let {registeredControllers} = this.state
        let filteredControllers = registeredControllers.filter((controller) => controller.id !== updatedController.id)
        if (filteredControllers.length < registeredControllers.length) {
            registeredControllers = filteredControllers
            registeredControllers.push(updatedController)
            this.setState({registeredControllers})
            sessionStorage.setItem(REGISTRATION_STATE_STORAGE_KEY, JSON.stringify(this.state))
        }
    }

    render() {
        let {loading, registeredControllers, errors, teamName} = this.state
        return <div className="col-12">
            {this.user && this.user.isSupport ?
                <UncontrolledAlert color="warning">
                    This is a Dealer Tool. Support users should only use this for demonstration.
                </UncontrolledAlert> :
                null}
            <h1 className="col-12 mb-0 d-block d-sm-none light-sf-orange font-weight-bold"><RegisterControllerIcon
                className="light-sf-blue mr-2"/>Register Controllers</h1>
            <h1 className="col-12 mb-0 d-none d-sm-block light-sf-orange font-weight-bold"><RegisterControllerIcon
                className="light-sf-blue mr-2"/>Register New Marksman Controllers</h1>
            <h3 className="col-12 d-block light-sf-blue mb-4">for {(teamName ? <strong>{teamName}</strong> : "your dealership")}</h3>
            <InfoAlert
                header="Registering Controllers"
                body="Registering a new Marksman controller will add it to the dealership's Assign Controllers list. You can register multiple controllers at once using the '+' button."
                alertKey={REGISTRATION_INFO_ALERT_KEY}/>


            {loading ?
                <Col xs={12} className="text-center m-4">
                    <Loader type="TailSpin" color="orange" width={60} height={60}/>
                </Col>:
                    <ProvisionControllerForm onSubmit={(serials) => this.submitForm(serials)}
                                             registration={true}/>}

            {registeredControllers.length > 0 ?
                <div id="registered-controllers" className="col-12 col-md-10 col-lg-8 offset-0 offset-md-1 offset-lg-2 mt-4 justify-content-center align-items-center">
                    <br/>
                    <hr/>
                    <br/>
                    <h3 className="col-12">Registered Controllers</h3>
                    <ListGroup>
                        {registeredControllers.map((controller, idx) => (
                            <ControllerRegistrationListItem controller={controller}
                                                            key={idx}
                                                            token={this.props.token}
                                                            handleWebSocketResponse={this.handleWebSocketResponse} />
                        ))}
                    </ListGroup>
                </div>:
                    null}

            {pageHelpers.renderErrorModalsForPage(errors, this)}
        </div>
    }
}
export default RegisterPage



// WEBPACK FOOTER //
// ./src/components/pages/controllers/RegisterPage.js